/* eslint-disable react/display-name */

import DataTable from '../table/tableOption'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getCasesDocuments } from '../../store/actions/casesActions'
import { Button } from 'react-bootstrap'
import { LoadingComponent } from 'recupero-comunes'

const Documentation = ({
  dataImplicated,
  dataDoc,
  loadingApi,
  onGetGestionCasesDocuments,
  form,
  idOrgano,
  idCaso
}) => {
  useEffect(() => {
    onGetGestionCasesDocuments({
      idOrgCaso: idOrgano,
      idCaso: idCaso,
      idImplicado: null
    })
  }, [])

  const handleClickTable = (row) => {}

  const [loading, setLoading] = useState(false)

  const columns = [
    {
      dataField: 'NombreDocumento',
      text: form?.formLabel['gestcasos-tab-documentacion-grilla-tipdocto'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'Obligatorio',
      text: form?.formLabel['gestcasos-tab-documentacion-grilla-obliga'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'Situacion',
      text: form?.formLabel['gestcasos-tab-documentacion-grilla-situacion'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'FechaCarga',
      text: form?.formLabel['gestcasos-tab-documentacion-grilla-fechacarga'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'Referencia',
      text: form?.formLabel['gestcasos-tab-documentacion-grilla-refdocto'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'UsuarioIngreso',
      text: form?.formLabel['gestcasos-tab-documentacion-grilla-usring'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    }
  ]

  const options = {
    columns,
    dataImplicated,
    data: dataDoc,
    id: 'IdDocumento',
    search: true,
    titleTableDoc: form?.formLabel['gestcasos-tab-documentacion-titledocu']
  }

  return (
    <div className='w-full'>
      <LoadingComponent show={loading || loadingApi} />
      {dataDoc && dataDoc.length > 0 && form?.formLabel ? (
        <div>
          <DataTable className='m-4' {...options} />
          <div
            style={{
              float: 'right'
            }}
          >
          </div>
        </div>
      ) : (
        <LoadingComponent />
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  dataDoc: state.cases.documents,
  loadingApi: state.cases.loading
})

const mapDispatchToProps = (dispatch) => ({
  onGetGestionCasesDocuments: (query) => dispatch(getCasesDocuments(query))
})

export default connect(mapStateToProps, mapDispatchToProps)(Documentation)
